// import { Tweet } from '@prisma/client'
import { TweetProcessed, TwitterUrl } from 'data/twitter/types'
// import { isEmpty } from 'lodash'
// import { TweetEntityUrlV2 } from 'twitter-api-v2'
// import { UrlEntity } from 'twitter-api-v2/dist/types/entities.types'
// import twitterText from 'twitter-text'
import twitterExtractMentions from 'twitter-extract-mentions'

export const getTweetUrl = (username: string, tweetId: string) => `https://twitter.com/${username}/status/${tweetId}`

export const getTwitterUserUrl = (username: string) => `https://twitter.com/${username}`

// const tweetPartsOptions = {
//   removeURLs: false,
//   removeUsersFromStart: true,
// }

export const getTweetTextWithUrls = (tweet: TweetProcessed, linkClassName: string, parent?: TweetProcessed) => {
  // console.log('GET TWEET WITH URLS', tweet)
  // if (isEmpty(tweet.urlsRaw) || !tweet.urlsRaw) {
  //   return tweet.text
  // }
  // return tweet.text
  const mentions = tweet.repliedToTweet
    ? twitterExtractMentions(tweet.repliedToTweet?.text)
    : []
  // const mentions = ['@UseBlotter', '@ThatMattMorris']
  // console.log('ExTRACTED MENTIONS', { mentions })

  const tweetTextWithPrefixMentionsRemoved = mentions.reduce((previous: string, current: string) => {
    // only replace first instance
    return previous.replace(`@${current} `, '')
  }, tweet.text)

  // console.log({ tweetTextWithPrefixMentionsRemoved })

  // Oddly, Twitter text prepends the screenname of the person you're
  // replying to at the beginning of your message, so we remove that
  const parentAuthor = parent?.author_username
  ? `@${parent?.author_username} `
  : ''
  // console.log('REPLACEE', tweetTextWithPrefixMentionsRemoved, parentAuthor)
  const tweetTextWithParentAuthorRemoved:string =
  tweetTextWithPrefixMentionsRemoved?.startsWith(parentAuthor)
      ? tweetTextWithPrefixMentionsRemoved.replace(parentAuthor, '')
      : tweetTextWithPrefixMentionsRemoved
  // // Not currently doing the below hack with case detection, it
  // // didn't work well
  // (unless you did it deliberately which we detect based on the
  // capitalization of the first letter of your message. Hacky!)
  // const firstLetter = tweetTextWithParentAuthorRemoved.substring(0, 1)
  // const tweetTextWithMaybeParentAuthorRemoved =
  //   firstLetter === firstLetter.toLowerCase()
  //     ? tweetTextWithPrefixMentionsRemoved
  //     : tweetTextWithParentAuthorRemoved
  // return tweetTextWithParentAuthorRemoved

  // const linkedText = twitterText.autoLink(tweetTextWithParentAuthorRemoved, {
  //   urlEntities: tweet.urlsRaw.map(url => ({
  //     ...url,
  //     indices: [url.start, url.end],
  //   })),
  // })
  // return linkedText

  if (!tweet.urlsRaw || tweet.urlsRaw.length === 0) {
    return tweetTextWithParentAuthorRemoved
  }
  // const tweetTextWithUrlsReplaced = tweet.urlsRaw.reduce((previous: string, url: TwitterUrl): string => {
  //   console.log('REPLACE', url)
  //   return previous.replace(url.url, `<a target='_out' href='${url.url}'>${url.unwound_url || url.display_url}</a>`)
  //   // return previous.replace(url., url.expanded_url)
  // }, tweetTextWithParentAuthorRemoved)
  // return tweetTextWithUrlsReplaced
  const tweetContentWithUrlsMarked = tweet.urlsRaw.reduce((previous: string, url: TwitterUrl): string => {
    // console.log('REPLACE', url)
    // const result = previous.map(node => node.)
    return previous.replace(url.url, `${magicStringGross}${magicStringUrl}${url.url}${magicStringGross}`)
  }, tweetTextWithParentAuthorRemoved)
  const tweetContentNodes = tweetContentWithUrlsMarked.split(magicStringGross)
  const finalTweetContent = tweetContentNodes.map((node, index) => {
    if (!node.startsWith(magicStringUrl)) {
      return <span key={node} dangerouslySetInnerHTML={{ __html: node }} />
    }
    const urlString = node.replace(magicStringUrl, '')
    const url = tweet.urlsRaw?.find(urlRaw => urlRaw.url === urlString)
    if (!url) {
      return urlString
    }
    return <a key={url.url} className={linkClassName} target='_out' href={url.url}>{url.unwound_url || url.display_url}</a>
  })
  // return '<p><strong>yoyoyoyo</strong></p>'
  return <>{finalTweetContent}</>
}

const magicStringGross = '<|_|>'
const magicStringUrl = '<blotter_url>'

export const cleanTweetContent = (tweetText: string) => {
  // const tweetParts = getTweetParts(tweetText)
  // const tweetTextWithNoUrls = getTweetTextWithoutExternalUrls(tweetText, tweetParts.urls)
  // const tweetTextWithNoLeadingUsers = getTweetTextWithoutLeadingUsers(tweetText, tweetParts.users)
  // return tweetTextWithNoLeadingUsers
  return tweetText
}

// const REGEX_URL = /(f|ht)tps?:\/\/([^\s\t\r\n<]*[^\s\t\r\n<)*_,\.])/g
// const REGEX_USER = /\B@([a-zA-Z0-9_]+)/g
// const REGEX_HASHTAG = /\B(#[á-úÁ-Úä-üÄ-Üa-zA-Z0-9_]+)/g

// const getTweetParts = (tweetText: string) => {
//   const urls = tweetText.match(REGEX_URL)
//   const users = tweetText.match(REGEX_USER)
//   const hashtags = tweetText.match(REGEX_HASHTAG)

//   const tweetParts = { urls, users, hashtags }
//   // console.log(tweetParts)
//   return tweetParts
// }

// const getTweetTextWithoutExternalUrls = (originalText: string, tweetUrls: RegExpMatchArray | null) => {
//   if (isEmpty(tweetUrls) || !tweetPartsOptions.removeURLs) {
//     return originalText
//   }
//   const cleanedText = tweetUrls?.reduce((prior: string, url: string) =>
//     prior.replaceAll(url, '')
//   , originalText)

//   return cleanedText || originalText
// }

// const REGEX_USERS_LEADING = /^((\ )?@([a-zA-Z0-9_]+))+/

// const getTweetTextWithoutLeadingUsers = (originalText: string, tweetUsers: RegExpMatchArray | null) => {
//   if (isEmpty(tweetUsers) || !tweetPartsOptions.removeUsersFromStart) {
//     return originalText
//   }
//   return originalText.replace(REGEX_USERS_LEADING, '')
// }

export const getDefaultUrlMessageForUrl = (url?: string) =>
  url
    ? `Like this and want to learn more? Check out my blog post: ${url}\r\n\r\nIf you found this helpful, your followers might too. Consider retweeting the first Tweet.
    `
    : ''
